import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { startCase, toLower } from 'lodash';
import { useDispatch } from 'react-redux';
import { FormProvider, useForm, useFieldArray } from 'react-hook-form';
import PlaceholderManagement from './PlaceHolderManagement/PlaceholderManagement';
import SearchBar from '../../Components/Utility/FilterAction/SearchBar';
import * as action from './PlaceHolderManagement/store/PlaceHolderManagement.action.js';

function RangePlan() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { childpath } = useParams();
  const [isDisabled, setIsDisabled] = useState(false);
  const btnClass1 = 'btn btn-white btn-back-lib border btn-active';
  const btnClass2 = 'btn btn-white btn-back-lib border';

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    formState: { errors, isValid },
    setValue,
    trigger,
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange' | 'onBlur',
  });

  const {
    fields: placeholderManagementFields,
    append: placeholderManagementAppend,
    remove: placeholderManagementRemove,
  } = useFieldArray({ control, name: 'placeholderManagement' });
  const [loaderOnSubmit, setLoaderOnSubmit] = useState(false);

  const checkPlaceholderCombination = async (data) => {
    if (data && data.placeholderManagement.length > 1) {
      setLoaderOnSubmit(true);
      const values = data.placeholderManagement;

      values.forEach(async (item, index) => {
        Object.keys(item).forEach((key) => {
          if (key !== 'placeholderQuanity') {
            const tmpARow = item[key]?.value || item[key];
            values.forEach(async (el, indx) => {
              Object.keys(el).forEach((keyJ) => {
                if (key !== 'placeholderQuanity') {
                  const tmpBRow = el[keyJ]?.value || el[keyJ];
                  if (tmpARow === tmpBRow && key === keyJ && indx !== 0) {
                    if (index !== indx) {
                      setError(`placeholderManagement[${indx}].${keyJ}`, {
                        type: 'custom',
                        message: 'allowed only unique value',
                      });
                    }
                  }
                }
              });
            });
          }
        });
      });
      setLoaderOnSubmit(false);
      return data;
    }
    setLoaderOnSubmit(false);
    return data;
  };

  const onSubmit = async (data) => {
    setIsDisabled(true);
    const dataArray = await checkPlaceholderCombination(data);
    if (isValid) {
      const { placeholderManagement } = dataArray;
      if (placeholderManagement) {
        const dataArr = placeholderManagement.map((item) => ({
          catOneId: item.category1.value,
          catTwoId: item.category2.value,
          brandId: item.brands.value,
          catThreeId: item.category3.value,
          catFourId: item.category4?.value,
          productDescription: item.productDescription.value,
          seasonId: item.seasons.value,
          month: item.month.value,
          year: item.year.value,
          newnessType: item.newnessType.value,
          sustainability: item.sustainability.value,
          priceBrand: item.priceBrand.value,
          targetPrice: item.targetPrice,
          placeholderQuantity: item.placeholderQuanity,
          actualQuantity: '55',
        }));
        await dispatch(action.addPlaceholderManagement({ placeholderManagement: dataArr }));
      }
    }

    setIsDisabled(false);
  };
  return (
    <div>
      <FormProvider
        {...{
          control,
          register,
          isValid,
          trigger,
          getValues,
          setValue,
          errors,
          placeholderManagementFields,
          placeholderManagementAppend,
          placeholderManagementRemove,
          loaderOnSubmit,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="page-title-filter sticky">
            <div className="title-container d-flex align-items-center">
              <h4 className="title">{startCase(toLower(childpath))}</h4>
            </div>
            <div className="floting-actions">
              <div className="search-filter">
                <SearchBar placeholder="Search" />
                <button
                  type="button"
                  className="filter-btn filter-button_delete"
                  title={t('RANGE_PLANS.SUPLIER_FILTER')}
                  aria-label={t('RANGE_PLANS.SUPLIER_FILTER')}
                >
                  <i className="icon-document" />
                </button>
                <button type="button" title={t('RANGE_PLANS.SORT')} className="filter-btn filter-button_delete">
                  <i className="icon-up-down-arrow" />
                  <span className="text-icon">{t('RANGE_PLANS.SORT')}</span>
                </button>
                <button disabled={isDisabled} type="submit" className={btnClass2}>
                  <span className="text-icon">{t('RANGE_PLANS.SAVE')}</span>
                </button>
              </div>
            </div>
            <div className="bom-list pb-3 mt-2">
              <Container fluid>
                <div className="d-flex justify-content-end align-items-center">
                  <Link
                    className={`cursor-pointer text-dark text-decoration-none ${childpath === 'planning-and-actual' ? btnClass1 : btnClass2}`}
                    to="range-plan/planning-and-actual"
                  >
                    <span className="text-icon">{t('RANGE_PLANS.PLANNING_AND_ACTUAL')}</span>
                  </Link>
                  <Link
                    className={`cursor-pointer text-dark text-decoration-none ${childpath === 'placeholder-management' ? btnClass1 : btnClass2}`}
                    to="range-plan/placeholder-management"
                  >
                    <span className="text-icon">{t('RANGE_PLANS.PLACEHOLDER_MANAGEMENT')}</span>
                  </Link>
                  <Link
                    className={`cursor-pointer text-dark text-decoration-none ${childpath === 'budget-planning' ? btnClass1 : btnClass2}`}
                    to="range-plan/budget-planning"
                  >
                    <span className="text-icon">{t('RANGE_PLANS.BUDGET_PLANNING')}</span>
                  </Link>
                </div>
                {childpath === 'placeholder-management' && <PlaceholderManagement />}
              </Container>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}

export default RangePlan;
